import styled from 'styled-components';

const PaginationStyle = styled.div`
	--marTop: var(--sp8x);

	--distance: var(--sp2x);
	--itemSize: var(--sp7x);
	--itemRadius: var(--sp0-5x);

	--itemBackgroundColor: var(--gray100);
	--itemBackgroundHoverColor: var(--red1000);
	--itemColor: var(--black900);
	--itemHoverColor: var(--white1000);

	--dotsSize: var(--sp1x);
	--dotsDistance: var(--sp2x);
	--dotsItemBackgroundColor: var(--gray100);

	width: fit-content;
	margin-top: var(--marTop);

	.pagination-inner-wrapper {
		display: flex;
		gap: var(--distance);

		&.one-dots-version {
		}
	}

	.prev-btn,
	.pagination-item,
	.next-btn {
		min-width: var(--itemSize);
		max-width: var(--itemSize);
		height: var(--itemSize);
		border-radius: var(--itemRadius);
		background-color: var(--itemBackgroundColor);
		color: var(--itemColor);
		font-size: var(--p1);
		line-height: var(--lineHeightL);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all var(--trTime) ease-out;
		cursor: pointer;

		i {
			font-size: var(--h6);
		}
	}

	.dots {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: var(--dotsDistance);

		.dots-item {
			width: var(--dotsSize);
			height: var(--dotsSize);
			border-radius: 50%;
			background-color: var(--dotsItemBackgroundColor);
		}
	}

	.pagination-item {
		&.active {
			background-color: var(--itemBackgroundHoverColor);
			color: var(--itemHoverColor);
			cursor: default;
			pointer-events: none;
		}
	}

	.prev-btn,
	.next-btn {
		&.disable {
			cursor: default;
			pointer-events: none;

			i {
				color: var(--black700);
			}
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.pagination-item {
				&:not(.active):hover {
					background-color: var(--itemBackgroundHoverColor);
					color: var(--itemHoverColor);
				}
			}

			.prev-btn,
			.next-btn {
				&:not(.disable):hover {
					background-color: var(--itemBackgroundHoverColor);
					color: var(--itemHoverColor);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marTop: var(--sp6x);

		--distance: var(--sp2x);
		--itemSize: var(--sp6x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marTop: var(--sp5x);

		--distance: var(--sp2x);
		--itemSize: var(--sp5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marTop: var(--sp4x);

		--distance: var(--sp1-5x);
		--itemSize: var(--sp5x);

		--dotsSize: 6px;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marTop: var(--sp4x);

		--distance: var(--sp1-5x);
		--itemSize: var(--sp5x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marTop: var(--sp3x);

		--distance: var(--sp1-5x);
		--itemSize: var(--sp5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--marTop: var(--sp3x);

		--distance: var(--sp1-5x);
		--itemSize: var(--sp5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--marTop: var(--sp3x);

		/* --distance: var(--sp1-5x); */
		/* --itemSize: var(--sp5x); */

		--dotsDistance: var(--sp0-5x);
		--itemSize: var(--sp4x);
		--distance: var(--sp1x);
	}
`;

export default PaginationStyle;
